export const baseUrl = process.env.REACT_APP_BASE_URL ?? 'https://rick.fripick.com/webservice/rest/'
export const providerPlatformBaseUrl = process.env.REACT_APP_PROVIDER_PLATFORM_BASE_URL ?? "https://provider.fripick.com/"
export const fripickBaseUrl = process.env.REACT_APP_FRIPICK_BASE_URL ?? "https://fripick.com/"
export const newProviderPlatformReportService = process.env.REACT_APP_REPORT_SERVICE_URL ?? "https://rick.fripick.com/webservice/rest/order-report-service";


export const benefitsMapping = {
    "giftcard": "Tarjeta de Regalo",
    "subsidio": "Subsidio",
    "asignacionDiaria": "Asignación Diaria",
    "asignacion": "Asignación",
    "limiteDeCredito": "Límite de Crédito",
    "promocion": "Promoción",
}